<template>
  <section>
    <div class="container content-padding">

      <template v-if="isEditing">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="mt-5">ขออภัยในความไม่สะดวก</h2>
            <h3>{{ editingRemark }}</h3>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12 text-center">
            <h2>โบนัสพิเศษประจำเดือน{{ getBonusTitle() }}</h2>
          </div>
        </div>

        <div class="container" style="padding: 0;" v-for="bonus in bonuses" :key="bonus.id">
          <div class="card">
            <div class="card-header">{{ bonus.title }}</div>
            <div class="card-body p-4">
              <div class="row">
                <div class="col-12 text-left">
                  <p style="font-weight: bold;">รายละเอียดกิจกรรม</p>
                  <div v-html="bonus.description"></div>
                  <p style="font-weight: bold;">ของรางวัล</p>
                  <p>
                    <ul>
                      <li v-for="reward in bonus.rewards_json" :key="reward">{{ reward }}</li>
                    </ul>
                  </p>
                  <p style="font-weight: bold;">เงื่อนไขกิจกรรม</p>
                  <p>
                    <ul>
                      <li v-for="condition in bonus.conditions_json" :key="condition">{{ condition }}</li>
                    </ul>
                  </p>
                  <p style="font-weight: bold;">ระยะเวลากิจกรรม</p>
                  <p>
                    <ul>
                      <li>{{ getBonusDateRange(bonus) }}</li>
                    </ul>
                  </p>
                  <p style="font-weight: bold;">เกณฑ์การพิจารณาคัดเลือกผู้ได้รางวัล</p>
                  <p>
                    <ul>
                      <li v-for="criteria in bonus.criteria_json" :key="criteria">{{ criteria }}</li>
                    </ul>
                  </p>
                  <p class="fw-bold">💙ビニート💙<br>𝗕𝗲𝗡𝗲𝗮𝘁 บริการสุดหัวใจ</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    data () {
      return {
        isEditing: '',
        editingRemark: '',
        professionalBonus: null,
        bonuses: [],
        queryData: {
          professional_id: this.$route.params.id,
          month: this.$route.query.month ? this.$route.query.month : moment().month() + 1,
          year: this.$route.query.year ? this.$route.query.year : moment().year()
        }
      }
    },
    components: {
      SweetModal
    },
    methods: {
      getBonusTitle () {
        const month = Number(this.queryData.month)
        const year = Number(this.queryData.year) + 543
        const date = moment(`${year}-${month}-01`)
        console.log('DEBUG', date)
        return date.locale('th').format('MMMM YYYY')
      },
      getBonusDateRange (bonus) {
        const startDate = moment(bonus.start_date)
        const endDate = moment(bonus.end_date)
        return `ตั้งแต่วันที่ ${startDate.format('D')} - ${endDate.format('D')} ${startDate.locale('th').format('MMMM')} ${parseInt(startDate.format('YYYY')) + 543}`
      },
      async loadProfessionalBonus (queryData) {
        this.$swal({
          title: 'ระบบกำลังประมวลผล',
          text: 'กรุณารอสักครู่ค่ะ',
          allowOutsideClick: true
        })
        this.$swal.showLoading()
        const url = `professionals/${queryData.professional_id}/bonus-stats`
        const { data } = await axios.get(url, { params: queryData })
        if (!data.error) {
          this.professionalBonus = data
          this.isEditing = this.professionalBonus.is_editing
          this.editingRemark = this.professionalBonus.editing_remark
          this.bonuses = this.professionalBonus.bonuses

          for (const bonus of this.bonuses) {
            bonus.rewards_json = JSON.parse(bonus.rewards_json)
            bonus.conditions_json = JSON.parse(bonus.conditions_json)
            bonus.criteria_json = JSON.parse(bonus.criteria_json)
          }
        }
        this.$swal.close()
      }
    },
    mounted () {
      this.loadProfessionalBonus(this.queryData)
    }
  }
</script>


<style lang="scss">
.card {
  li {
    margin-left: 1.5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/professional/ProfessionalBonus.vue